import SubDefaultLayout from "../../components/SubDefaultLayout";
import Slider from "../../components/Slider";
import { Button, Card, Col, Divider, Input, Row, Tooltip, Typography } from "antd";
import { StyleSheet } from "../../StyleSheet";
import { useDispatch, useSelector } from "react-redux";
import { getGeneralData, setUpdateAlias } from "../../stores/slices/generalDataSlice";
import { useCallback, useEffect, useState } from "react";
import { clearDueDate, fillDueDateSlice, getDueDate } from "../../stores/slices/dueDateSlice";
import { AppDispatch } from "../../stores/store";
import _ from "lodash";
import Barcode from "react-barcode";
import { CloseOutlined, EditOutlined, RightOutlined, SaveOutlined } from "@ant-design/icons";
import Loading from "../../components/Loading";
import { useNavigate } from "react-router-dom";
import InfoCardComponent from "../../components/InfoCardComponent";
import ListAccordion, { ListAccordionItem } from "../../components/ListAccordion";
import RenderAllServicesCards from "../myServices/components/RenderAllServicesCards";
import { DispatchAlertConfirmationOpts, RequestAlias, RequestRemoveSavedCard, ResponseEndCard, ResponsePackageActivation, ResponsePackageGroups } from "../../types/common";
import { getCount } from "../../stores/slices/countSlice";
import RenderAllActivationsCards from "../myServices/components/RenderAllActivationsCards";
import { forgotPassword, getGetSavedCards, removeSavedCard, updateAliasRoot, validateAllServices } from "../../methods/Methods";
import { AlertSliceInterface, clearAlert, setAlert, showAlert } from "../../stores/slices/alertSlice";
import ListCardAccordion from "../../components/ListCardAccordion";
import { clearAlertConfirmation, setAlertConfirmation, showAlertConfirmation } from "../../stores/slices/alertConfirmationSlice";
import { fillDataServiceSlice, getConfigurableServiceState } from "../../stores/slices/configurableServicesSlice";

const { Text } = Typography;

type NavigationItem =
    | { title: string; path: string; actionType?: undefined }
    | { title: string; actionType: "DELETE_ACCOUNT" | "CHANGE_PASSWORD" | "UPDATE_PROFILE"; path?: undefined };

const MyID = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const generalData = useSelector(getGeneralData);
    const [idCliente, setIdCliente] = useState<string>("");
    const dueDate = useSelector(getDueDate);
    const [loading, setLoading] = useState<boolean>(false);
    const [nombre, setNombre] = useState<string>("");
    const [limitPayment, setLimitPayment] = useState<number>(0);
    const [barcode, setBarcode] = useState<string>("");
    const [services, setServices] = useState<ResponsePackageGroups[]>([]);
    const [activations, setActivations] = useState<ResponsePackageActivation[]>([]);
    const [loadingServices, setLoadingServices] = useState<boolean>(false);
    const [hasErrorServices, setHasErrorServices] = useState<boolean>(false);
    const { count } = useSelector(getCount);
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [arrayListSavedCard, setArrayListSavedCard] = useState<ResponseEndCard[]>([]);
    const [showSavedCards, setShowSavedCards] = useState(false);
    const confService = useSelector(getConfigurableServiceState);
    const canUpdateContactData = confService.dataList.some(
        (service) => service.name.startsWith("DAF_UPDATE_DATA_") && service.enabled
    );

    const [isEditing, setIsEditing] = useState(false);
    const [alias, setAlias] = useState("");
    const [aliasTmp, setAliasTmp] = useState(alias);

    const items: ListAccordionItem[] = [
        {
            key: 0,
            title: "Contrata más Servicios",

            children: <RenderAllServicesCards
                services={services}
                loading={loadingServices}
                hasError={hasErrorServices}
            />
        },
        {
            key: 1,
            title: "Activa tus Servicios",

            children: <RenderAllActivationsCards
                activations={activations}
                loading={loadingServices}
                hasError={hasErrorServices}
                dataConf={confService}
            />
        },
    ];

    const updateProfileItem = { title: "Actualizar Datos de Contacto", actionType: "UPDATE_PROFILE" as const };

    let itemsOpt: Array<{ title: string; actionType: "DELETE_ACCOUNT" | "CHANGE_PASSWORD" | "UPDATE_PROFILE" }> = [
        ...(canUpdateContactData ? [updateProfileItem] : []),
        { title: "Cambiar Contraseña", actionType: "CHANGE_PASSWORD" },
        { title: "Dar de Baja mi Cuenta", actionType: "DELETE_ACCOUNT" },
    ];

    const navigationData: NavigationItem[] = [
        { title: 'Contratos Asociados', path: '/associated-contracts' },
        ...itemsOpt,
    ];


    const handleDispatchAlertModal = useCallback(() => {
        dispatch(showAlert(false));
        dispatch(clearAlert());
    }, [dispatch]);

    const openAlertModal = useCallback((option: AlertSliceInterface) => {
        dispatch(setAlert({
            show: option.show,
            type: option.type as "INFO" | "SUCCESS" | "ERROR",
            title: option.title,
            message: option.message,
            onFinalize: option.onFinalize
        }));
    }, [dispatch]);

    const handleOnClick = (actionType: string) => {
        switch (actionType) {
            case "CHANGE_PASSWORD":
                updatePasswordFnt();
                break;
            case "DELETE_ACCOUNT":
                openAlertModal({
                    show: true,
                    type: "INFO",
                    title: "¡Estimado Usuario!",
                    message: "Si deseas dar de baja tus credenciales de ingreso a servicios en línea, debes comunicarte con nuestro servicio de atención al cliente al número: 33 9690 0000.",
                    onFinalize: handleDispatchAlertModal,
                });
                break;
            case "UPDATE_PROFILE":
                navigate("/my-data/update-data")
                break;
            default:
                console.warn("Acción no reconocida:", actionType);
        }
    };

    const updatePasswordFnt = () => {
        let dataRequest = {
            telefonoCelular: phone,
            email: email,
        }
        let typeStatus = "";
        let messageAlert = "";
        setLoading(true);
        forgotPassword(dataRequest, idCliente)
            .then((response) => {
                if (response.data && response.data.data[0] && response.data.data[0].message) {
                    if (response.data.data[0].message !== "Los datos proporcionados no son correctos.") {
                        typeStatus = "SUCCESS";
                        messageAlert = response.data.data[0].message;
                    } else {
                        typeStatus = "ERROR";
                        messageAlert = "Hubo un error al realizar la petición.\nIntente más tarde.";
                    }
                } else {
                    typeStatus = "ERROR";
                    messageAlert = "Ocurrió un error al realizar la petición.\nIntente más tarde.";
                }
                let dispatchAlert: AlertSliceInterface = {
                    show: true,
                    type: typeStatus as "INFO" | "SUCCESS" | "ERROR",
                    title: "¡Estimado Usuario!",
                    message: messageAlert,
                    onFinalize: () => handleDispatchAlertModal()
                }
                openAlertModal(dispatchAlert);
                setLoading(false);
            })
            .catch(() => {
                let dispatchAlert: AlertSliceInterface = {
                    show: true,
                    type: "ERROR",
                    title: "¡Estimado Usuario!",
                    message: "Hubo un error al procesar su solicitud. \nIntente más tarde.",
                    onFinalize: () => handleDispatchAlertModal()
                }
                openAlertModal(dispatchAlert);
                setLoading(false);
            });
    };

    useEffect(() => {
        dispatch(fillDataServiceSlice())
        if (generalData.selectedContract !== null) {
            setIdCliente(
                generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor
            );
            setNombre(
                generalData.selectedContract.nombre +
                " " +
                generalData.selectedContract.apellidoPaterno +
                " " +
                generalData.selectedContract.apellidoMaterno
            );
            setLimitPayment(generalData.selectedContract.diaDeCorte);
            setEmail(generalData.selectedContract.email);
            setPhone(generalData.selectedContract.telefonoCelular);
            setAlias(generalData.selectedContract.alias);
        }
    }, [generalData.selectedContract, dispatch, idCliente]);

    const handleEditPress = () => {
        setAliasTmp(alias);
        setIsEditing(true);
    };

    const handleSavePress = async () => {
        let typeStatus = "";

        if (_.isEmpty(aliasTmp.trim())) {
            const dispatchAlert: AlertSliceInterface = {
                show: true,
                type: "INFO",
                title: "¡Estimado Usuario!",
                message: "El campo Alias está vacío.\n",
                onFinalize: () => handleDispatchAlertModal()
            };
            openAlertModal(dispatchAlert);
            return;
        }

        if (aliasTmp.trim() === alias.trim()) {
            const dispatchAlert: AlertSliceInterface = {
                show: true,
                type: "INFO",
                title: "¡Estimado Usuario!",
                message: "No se han detectado cambios en el Alias.",
                onFinalize: () => handleDispatchAlertModal()
            };
            openAlertModal(dispatchAlert);
            return;
        }

        setLoading(true);
        let objUpdate: RequestAlias = {
            alias: aliasTmp.trim()
        }

        updateAliasRoot(objUpdate, idCliente)
            .then(async (response) => {
                if (response.data && response.data.data && response.data.data[0] && response.data.data[0].status) {
                    typeStatus = "SUCCESS";
                    dispatch(setUpdateAlias({
                        idCliente: idCliente,
                        alias: objUpdate.alias,
                        action: "UPDATE"
                    }));
                } else {
                    typeStatus = "ERROR";
                }
                let dispatchAlert: AlertSliceInterface = {
                    show: true,
                    type: typeStatus as "INFO" | "SUCCESS" | "ERROR",
                    title: "Alias Actualizado",
                    message: response.data.data[0].message,
                    onFinalize: () => handleDispatchAlertModal()
                }
                openAlertModal(dispatchAlert);
                setLoading(false);
                setIsEditing(false);
            })
            .catch(() => {
                let dispatchAlert: AlertSliceInterface = {
                    show: true,
                    type: "ERROR",
                    title: "¡Estimado Usuario!",
                    message: "Hubo un error al actualizar el alias del contrato. \nIntente más tarde.",
                    onFinalize: () => handleDispatchAlertModal()
                }
                openAlertModal(dispatchAlert);
                setLoading(false);
            })
    }

    const fetchSavedCards = useCallback(() => {
        setShowSavedCards(false);
        setLoading(true);
        getGetSavedCards(idCliente)
            .then((response) => {
                if (response.data.data[0].status && response.data.data[0].endCardList) {
                    setArrayListSavedCard(response.data.data[0].endCardList);
                    setShowSavedCards(true);
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            })
    }, [idCliente]);

    useEffect(() => {
        if (idCliente) {
            fetchSavedCards();
        }
    }, [idCliente, fetchSavedCards]);

    const consultarDueDate = useCallback(() => {
        if (idCliente) {
            setLoading(true);
            dispatch(fillDueDateSlice({ clientId: idCliente }));
        }
    }, [dispatch, idCliente]);

    useEffect(() => {
        if (dueDate.data) {
            setBarcode(dueDate.data.generalData.codigoBarras);
            setLoading(false);
        } else {
            consultarDueDate();
        }
    }, [dueDate.data, consultarDueDate]);


    const onPressBtnPrimary = useCallback((item: ResponseEndCard) => {
        dispatch(showAlertConfirmation(false));
        dispatch(clearAlertConfirmation());
        setLoading(true);
        let requestRemoveSavedCard: RequestRemoveSavedCard = {
            tarjeta: item.encryptedCard
        }
        let typeStatus = "";
        let messageAlert = "";
        removeSavedCard(requestRemoveSavedCard, idCliente)
            .then((response) => {
                if (response.data && response.data.data[0]) {
                    typeStatus = response.data.data[0].status ? "SUCCESS" : "ERROR";
                    messageAlert = response.data.data[0].message;
                    if (response.data.data[0].status) {
                        fetchSavedCards();
                    }
                } else {
                    typeStatus = "ERROR";
                    messageAlert = "Ocurrió un error al realizar la petición.\nIntente más tarde.";
                }
                let dispatchStatusPay: AlertSliceInterface = {
                    show: true,
                    type: typeStatus as "INFO" | "SUCCESS" | "ERROR",
                    title: "¡Estimado Usuario!",
                    message: messageAlert,
                    onFinalize: () => handleDispatchAlertModal()
                }
                openAlertModal(dispatchStatusPay);
                setLoading(false);
            })
            .catch(() => {
                let dispatchAlert: AlertSliceInterface = {
                    show: true,
                    type: "ERROR",
                    title: "¡Estimado Usuario!",
                    message: "Hubo un error al procesar su solicitud. \nIntente más tarde.",
                    onFinalize: () => handleDispatchAlertModal()
                }
                openAlertModal(dispatchAlert);
                setLoading(false);
            })
    }, [dispatch, handleDispatchAlertModal, idCliente, openAlertModal, fetchSavedCards]);

    const onPressBtnSecondary = useCallback(() => {
        dispatch(showAlertConfirmation(false));
        dispatch(clearAlertConfirmation());
    }, [dispatch]);


    const openAlertModalConfirm = useCallback((option: DispatchAlertConfirmationOpts) => {
        dispatch(setAlertConfirmation({
            show: true,
            onPressBtnPrimary: option.onPressBtnPrimary,
            onPressBtnSecondary: option.onPressBtnSecondary,
            message: option.message
        }));
    }, [dispatch]);


    const handleDeleteSavedCard = (item: ResponseEndCard) => {
        let dispatchAlert: DispatchAlertConfirmationOpts = {
            onPressBtnPrimary: () => onPressBtnPrimary(item),
            onPressBtnSecondary: () => onPressBtnSecondary(),
            message: "¿Está seguro que desea eliminar la tarjeta con terminación " + item.endCard + "?"
        }
        openAlertModalConfirm(dispatchAlert);
    };

    const itemsSavedCard: ListAccordionItem[] = [
        {
            key: 0,
            title: "Tarjetas Guardadas",
            children: <ListCardAccordion
                items={arrayListSavedCard}
                handleClick={handleDeleteSavedCard}
            />
        },
    ];

    const validateServices = useCallback(async (clientId: string) => {
        setLoadingServices(true);
        await validateAllServices(clientId)
            .then((response) => {
                if (response.data.data[0].packageGroups && !_.isEmpty(response.data.data[0].packageGroups)) {
                    setServices(response.data.data[0].packageGroups);
                }
                if (response.data.data[0].activationList && !_.isEmpty(response.data.data[0].activationList)) {
                    setActivations(response.data.data[0].activationList);
                }
                setLoadingServices(false);
                setHasErrorServices(false);
            })
            .catch(() => {
                setLoadingServices(false);
                setHasErrorServices(true);
            })
    }, [setServices]);

    useEffect(() => {
        if (idCliente) {
            validateServices(idCliente);
        }
    }, [idCliente, validateServices, count]);

    useEffect(() => {
        if (!_.isEmpty(idCliente)) {
            if (dueDate.clientId !== idCliente) {
                dispatch(clearDueDate());
            }
        }
    }, [idCliente, dueDate, dispatch]);

    useEffect(() => {
        switch (dueDate.status) {
            case 1:
                setLoading(false);
                break;
            case 2:
                setLoading(false);
                break;
            default:
                setLoading(true);
                break;
        }
    }, [dueDate.status]);

    return (
        <>
            {
                loading ?
                    <Loading />
                    :
                    <SubDefaultLayout title={"Mis Datos"}>
                        {(!dueDate.data) ? (
                            <InfoCardComponent title="¡Estimado Usuario!" description="Hubo un problema al cargar la información. Intente nuevamente." />
                        ) : (
                            <>
                                <Slider />
                                <Row gutter={[12, 12]} style={styles.rowPrincipal}>
                                    <Col xs={24} xl={14}>
                                        <Card style={{ ...styles.cardRoot }}>
                                            <Row style={{ display: "flex", justifyContent: "center", alignItems: "center", width: '100%' }}>
                                                <Col xs={20} xl={20}>
                                                    <div style={styles.aliasContainerStyle}>
                                                        {isEditing ? (
                                                            <Input
                                                                value={aliasTmp}
                                                                style={styles.inputText}
                                                                placeholder='Alias'
                                                                onChange={(e) => setAliasTmp(e.target.value)}
                                                            />
                                                        ) : (
                                                            <Text
                                                                style={styles.textPrincipal}
                                                                title={alias}
                                                            >
                                                                {alias}
                                                            </Text>
                                                        )}
                                                    </div>
                                                </Col>
                                                <Col
                                                    span={4}
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: isEditing ? "space-around" : "flex-end",
                                                        paddingRight: isEditing ? 0 : 15,
                                                        marginTop: 15, marginBottom: 10
                                                    }}
                                                >
                                                    {isEditing ? (
                                                        <>
                                                            <SaveOutlined
                                                                style={{ ...styles.icon }}
                                                                onClick={() => handleSavePress()}
                                                                title="Guardar"
                                                            />
                                                            <CloseOutlined
                                                                style={styles.icon}
                                                                onClick={() => setIsEditing(false)}
                                                                title="Cancelar"
                                                            />
                                                        </>
                                                    ) : (
                                                        <EditOutlined
                                                            style={styles.icon}
                                                            onClick={() => handleEditPress()}
                                                            title="Editar"
                                                        />
                                                    )}
                                                </Col>
                                            </Row>
                                            <Row style={{ display: "flex", justifyContent: "center", textAlign: "center", marginTop: 10 }}>
                                                <Col xs={11} xl={11} style={{ marginTop: 10 }}>
                                                    <div>
                                                        <Text style={styles.textRegular}>
                                                            Suscriptor
                                                        </Text>
                                                    </div>
                                                    <div style={{ marginTop: 2 }}>
                                                        <Text style={styles.textColor}>
                                                            {idCliente}
                                                        </Text>
                                                    </div>
                                                    <br />
                                                    <div>
                                                        <Text style={styles.textRegular}>
                                                            Nombre
                                                        </Text>
                                                    </div>
                                                    <div style={{ marginTop: 2 }}>
                                                        <Tooltip overlayInnerStyle={{ backgroundColor: '#000', color: 'white' }} title={nombre}>
                                                            <Text style={styles.textColor}>
                                                                {nombre}
                                                            </Text>
                                                        </Tooltip>
                                                    </div>
                                                </Col>
                                                <Col xs={2} xl={2}>
                                                    <Divider type="vertical" style={styles.divider} />
                                                </Col>
                                                <Col xs={11} xl={11} style={{ marginTop: 10 }}>
                                                    <div>
                                                        <Text style={styles.textRegular}>
                                                            Teléfono
                                                        </Text>
                                                    </div>
                                                    <div style={{ marginTop: 2 }}>
                                                        <Text style={styles.textColor}>
                                                            {generalData.selectedContract?.telefonoCelular}
                                                        </Text>
                                                    </div>
                                                    <br />
                                                    <div>
                                                        <Text style={styles.textRegular}>
                                                            Correo electrónico
                                                        </Text>
                                                    </div>
                                                    <div style={{ marginTop: 2 }}>
                                                        <Tooltip overlayInnerStyle={{ backgroundColor: '#000', color: 'white' }} title={generalData.selectedContract?.email}>
                                                            <Text style={styles.textColor}>
                                                                {generalData.selectedContract?.email}
                                                            </Text>
                                                        </Tooltip>
                                                    </div>
                                                    <br />
                                                    <div>
                                                        <Text style={styles.textRegular}>
                                                            CURP
                                                        </Text>
                                                    </div>
                                                    <div style={{ marginTop: 2 }}>
                                                        <Tooltip overlayInnerStyle={{ backgroundColor: '#000', color: 'white' }} title={generalData.selectedContract?.email}>
                                                            <Text style={styles.textColor}>
                                                                {generalData.selectedContract?.curp}
                                                            </Text>
                                                        </Tooltip>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row style={{ display: "flex", justifyContent: "center", textAlign: "center" }}>
                                                <Col>
                                                    <br />
                                                    <div>
                                                        <Text style={styles.textRegular}>
                                                            Fecha de corte
                                                        </Text>
                                                    </div>
                                                    <div style={{ marginTop: 2 }}>
                                                        <Text style={styles.textColor}>
                                                            Día {limitPayment} del mes en curso
                                                        </Text>
                                                    </div>
                                                </Col>
                                            </Row>
                                            {!_.isEmpty(barcode) ? (
                                                <Row>
                                                    <Col span={24} style={{ justifyContent: 'center', marginTop: 15, display: 'flex' }}>
                                                        <Barcode
                                                            fontSize={15}
                                                            value={barcode}
                                                            background={'transparent'}
                                                            format="CODE128"
                                                            width={1.5}
                                                            height={60} />
                                                    </Col>
                                                </Row>
                                            ) : null}
                                        </Card>
                                    </Col>
                                    <Col xs={24} xl={10}>
                                        {navigationData.map((item, index) => (
                                            <Card
                                                key={index}
                                                style={{ ...styles.cardRoot, cursor: "pointer" }}
                                                onClick={() => {
                                                    if (item.path) {
                                                        navigate(item.path);
                                                    } else if (item.actionType) {
                                                        handleOnClick(item.actionType);
                                                    }
                                                }}
                                            >
                                                <Row align={"middle"}>
                                                    <Col xs={18} xl={18}>
                                                        <Text style={{ ...styles.textRegular, flex: 1, color: '#797e84', fontWeight: 600 }}>{item.title}</Text>
                                                    </Col>
                                                    <Col xs={6} xl={6} style={{ display: 'flex', justifyContent: "flex-end" }}>
                                                        <Button icon={<RightOutlined style={{ color: '#797e84' }} />} type="text" />
                                                    </Col>
                                                </Row>
                                            </Card>
                                        ))}
                                    </Col>
                                </Row>
                                {
                                    showSavedCards && (
                                        <Row>
                                            <Col xs={24} xl={14}>
                                                <ListAccordion
                                                    items={itemsSavedCard}
                                                />
                                            </Col>
                                        </Row>
                                    )
                                }
                                <Col span={24}>
                                    <ListAccordion
                                        items={items}
                                        focus={0}
                                    />
                                </Col>
                            </>
                        )}
                    </SubDefaultLayout >
            }
        </>
    );
};

const styles = StyleSheet.create({
    rowPrincipal: {
        marginTop: 30,
        display: "flex",
    },
    cardRoot: {
        backgroundColor: "white",
        marginBottom: 15,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 20,
    },
    textPrincipal: {
        color: "black",
        fontSize: 20,
        fontWeight: 600,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    textRegular: {
        color: "black",
        fontSize: 16,
        fontWeight: 500,
    },
    textColor: {
        color: "#115ac2",
        fontSize: 18,
        fontWeight: 600,
        display: 'block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    icon: {
        fontSize: 20,
        color: "#767b81",
    },
    aliasContainerStyle: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
        color: "black",
        fontSize: 20,
        fontWeight: 600,
        textAlign: 'center',
        paddingLeft: 35,
        marginLeft: 35
    },
    divider: {
        backgroundColor: '#0055c2',
        height: 220,
        width: 1
    },
    inputText: {
        color: "#000000",
        border: 'none',
        backgroundColor: 'transparent',
        outline: 'none',
        fontSize: 20,
        fontWeight: 600,
        width: '100%',
        padding: 0,
        boxShadow: 'none',
    },
    mainContainer: {
        width: "58%",
        flexDirection: "column",
    },
});

export default MyID;
